import { render, staticRenderFns } from "./SettingCustomersGuest.vue?vue&type=template&id=656c6a6c&"
import script from "./SettingCustomersGuest.vue?vue&type=script&lang=ts&"
export * from "./SettingCustomersGuest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports